"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextArea = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var StyledTextArea = _styledComponents.default.textarea.withConfig({
  displayName: "TextAreastyle__StyledTextArea",
  componentId: "sc-5wh1x8-0"
})(["", ";"], function (_ref) {
  var textArea = _ref.theme.textArea,
    disabled = _ref.disabled;
  return (0, _styledComponents.css)(["background:", ";border-radius:", ";border:", ";color:", ";display:block;font-size:", ";max-width:100%;padding:", ";width:100%;resize:vertical;&::-webkit-input-placeholder,&::placeholder{color:", ";}", ";"], textArea.backgroundColor, textArea.borderRadius, textArea.border, textArea.textColor, textArea.fontSize, textArea.padding, textArea.placeholderColor, disabled && (0, _styledComponents.css)(["color:", ";cursor:not-allowed;background-color:", ";"], textArea.textColorDisabled, textArea.backgroundColorDisabled));
});
exports.StyledTextArea = StyledTextArea;